<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Unallocated Payments / Deposits</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
            <v-btn color="accent" @click="resetLoader" text>
             Reset Loader
            </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-btn color="accent" @click.native="paymentDialog = true" text>
              <v-icon left>mdi-plus</v-icon> New Deposit
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row dense class="subtitle-2 text--primary mt-2">

          <v-col cols="12">
            <v-text-field label="Search" v-model="search" outlined dense></v-text-field>
            <v-data-table :mobile-breakpoint="0" :headers="headers" :items="reportData" :search="search">
              <template v-slot:item.Amount="{ item }">
                <span>{{ item.Amount | currency }}</span>
              </template>

              <template v-slot:item.date="{ item }">
                <span style="display: inline-block; min-width: 80px; width: 80px">
                  {{
                    item.date | date
                  }}
                </span>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn :to="`/allocate-payment/${item.id}`" color="accent" text>
                  <v-icon left>mdi-card-bulleted</v-icon> Apply To Invoices
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-col>
        </v-row>



        <!-- payment dialog -->
        <v-dialog v-model="paymentDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title>Deposit Payment</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="paymentDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-form ref="depositForm" v-model="valid" :lazy-validation="lazy">
                  <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" md="6">
                      <v-autocomplete v-model="record.CustomerId" :items="customers" item-text="Name" item-value="id"
                        label="Select Customer" outlined dense clearable :search-input.sync="searchCustomers"
                        :rules="inputRules"></v-autocomplete>
                    </v-col>

                    <v-col cols="6">
                      <DatePicker @date="setDate" :myDate="record.DocDate" :title="`Select Payment Date`"></DatePicker>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field type="number" autocomplete="off" outlined dense label="Amount Paid"
                        v-model="record.AmountPaid" :rules="inputRules"></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-autocomplete v-model="record.AccountId" :items="accounts" item-text="Name" item-value="id"
                        label="Bank Account" outlined dense clearable :rules="inputRules"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                      <DatePicker class="mt-2" @date="setChequeDate" :myDate="record.ChequeDate"
                        :title="`Select Cheque Date`">
                      </DatePicker>
                    </v-col>

                    <v-col cols="12" md="6">
                      <DatePicker @date="setBankDate" :myDate="record.BankDate" :title="`Select Bank Date`">
                      </DatePicker>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="primary" @click="createDeposit" :loading="loader">
                        <v-icon left>mdi-content-save</v-icon> Create Deposit
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>

              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end -->

        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

export default {
  components: {},
  data: () => ({
    record: {},
    reportData: [],
    menu1: false,
    menu2: false,
    loader: false,
    customers: [],
    accounts: [],
    searchCustomers: null,
    valid: false,
    lazy: false,
    inputRules: [v => !!v || "Required"],
    zeroValue: 0,
    SoldBy: null,
    paymentDialog: false,
    PaymentMode: null,
    pageItems: 200,
    totalDebt: 0,
    search: "",
    AllPayments: [],
    TotalPayments: 0,
    date: null,
    headers: [
      { text: "Customer", value: "customer.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Payment Mode", value: "Account.Name" },
      { text: "Date", value: "date" },
      { text: "Action", value: "action" },
    ],
    debtors: []
  }),
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    userRole() {
      return localStorage.getItem("userRole");
    }
  },
  watch: {
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    resetLoader() {
      this.$store.commit("btnLoader", false);
    },
    setDate(date) {
      this.record.DocDate = date;
    },
    setChequeDate(date) {
      this.record.ChequeDate = date;
    },
    setBankDate(date) {
      this.record.BankDate = date;
    },
    createDeposit() {
      if (!this.$refs.depositForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      if (this.record.DocDate == null || this.record.DocDate == undefined) {
        this.$refs.snackbar.show("Please select a date", "red");
        return;
      }

      var data = {
        AccountId: parseInt(this.record.AccountId),
        AmountPaid: parseFloat(this.record.AmountPaid),
        RequestDocDate: this.record.DocDate,
        RequestBankDate: this.record.BankDate,
        RequestChequeDate: this.record.ChequeDate,
        CustomerId: parseInt(this.record.CustomerId),
        RefNo: "",
        Narration: "",
        SelectedIds: [],
      };

      const url = "/create-deposit";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.record = {};
            self.paymentDialog = false;
            self.getReport();
            this.$refs.snackbar.show("Deposit successful", "green");
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const storeId = this.activeStore;
      const url = `/fetch-deposits/${storeId}`;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          console.log(res, " payments response");
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData.payments;
            self.TotalAmount = res.ResponseData.TotalAmountPaid;
            self.loader = false;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });

    },
    fetchAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.fetchAccounts(), this.getReport()]);
  }
};
</script>